import { Button, Card, FormLayout, Heading, Paragraph, SyntaxIcon, Text } from "@expressable/syntax-ds"
import { useSignupDirectCtx } from "domains/signupDirect/context"
import { HeadingCombo } from "domains/signupDirect/SyntaxComps/HeadingCombo";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const EligibilityPCPInformation = () => {
    const { t } = useTranslation();
    const { onUpdateEligibilityHasPCP } = useSignupDirectCtx();

    const { name, officeName, phone } = useWatch({ name: 'primaryPhysician' });

    const onEditPCP = () => onUpdateEligibilityHasPCP(false);

    return (
        <>
            <FormLayout.Fields className="mobile-xs-d:gap-e24 tablet-d:gap-e32">
                <HeadingCombo>
                    <Heading noDefaultMargins level="h5">
                        {t('directSignup.sections.primaryPhysician.title')}
                    </Heading>
                    <Paragraph variant="secondary" size="md">
                        {t('directSignup.sections.primaryPhysician.subtitleEligibilityPCP')}
                    </Paragraph>
                </HeadingCombo>
            </FormLayout.Fields>
            <Card noDefaultPaddings>
                <div className="flex flex-col">
                    <Heading level="h6" className="gap-e16 flex items-center px-32 pt-32" noDefaultMargins>
                        <div className='bg-orchid-50 text-purple-500 rounded-full p-2'>
                            <SyntaxIcon weight="fill" size="xl" icon="Person" className="rounded-full" />
                        </div>
                        {t('directSignup.sections.primaryPhysician.eligibilityPcppInfoTitle')}
                    </Heading>

                    <div className="p-e32">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-e32 mb-32 md:mb-40">

                            {name && (
                                <div className="flex flex-col gap-e8">
                                    <Text variant="label" className="text-gray-600 text-xs">
                                        {t('directSignup.sections.primaryPhysician.labels.physicianName')}
                                    </Text>
                                    <div className="border-purple-300  bg-white">
                                        <Text className="text-gray-900">
                                            {name}
                                        </Text>
                                    </div>
                                </div>
                            )}

                            {officeName && (
                                <div className="flex flex-col gap-e8">
                                    <Text variant="label" className="text-gray-600 text-xs">
                                        {t('directSignup.sections.primaryPhysician.labels.physicianOfficeName')}
                                    </Text>
                                    <div className="border-purple-300  bg-white">
                                        <Text className="text-gray-900">
                                            {officeName}
                                        </Text>
                                    </div>
                                </div>
                            )}

                            {phone && (
                                <div className="flex flex-col gap-e8">
                                    <Text variant="label" className="text-gray-600 text-xs">
                                        {t('directSignup.sections.primaryPhysician.labels.eligibilityPhysicianPhone')}
                                    </Text>
                                    <div className="border-purple-300  bg-white">
                                        <Text className="text-gray-900">
                                            {phone}
                                        </Text>
                                    </div>
                                </div>
                            )}
                        </div>

                        <Button variant="link" size="sm" onClick={onEditPCP}>{t('directSignup.sections.primaryPhysician.editPCP')}</Button>
                    </div>

                    <div className="border-border-purple-300 border-t p-e32 md:p-e40">
                        <Paragraph className="text-sm" size="sm" variant="secondary">
                            {t('directSignup.sections.primaryPhysician.eliigibilityPcpDisclaimer')}
                        </Paragraph>

                    </div>
                </div>
            </Card>
        </>
    )
}